module.exports = __webpack_public_path__ + "media/dashboard/assets/BITESPEED-2e5edb1f2392d0c86a962aa771103345.svg";